<template>
  <div class="global-notifications" v-if="notifications.length">
    <div
      v-for="notification in notifications"
      :class="'notification-container ' + notification.type"
      :key="notification.uid"
    >
      <button
        class="close"
        @click.prevent="removeNotification(notification.uid)"
      >
        close
      </button>
      <!-- ERROR -->
      <div class="notification" v-if="notification.type === 'error'">
        <img src="@/assets/error.png" alt class="thumbnail" />
        <div class="content">
          <h1>Something went wrong</h1>
          <p>{{ notification.data }}</p>
        </div>
      </div>

      <!-- LEVELED UP -->
      <div class="notification" v-if="notification.type === 'leveledUp'">
        <img
          :src="require(`@/assets/ranks/${notification.data}.png`)"
          alt
          class="thumbnail"
        />
        <div class="content">
          <h1>New Rank Achieved: {{ notification.data }}</h1>
          <p>You have just ranked up to {{ notification.data }}!</p>
        </div>
      </div>

      <!-- ACHIEVEMENT -->
      <div class="notification" v-if="notification.type === 'achievement'">
        <router-link :to="`/achievements?f=${notification.data.id}`">
          <img
            class="thumbnail"
            :src="require(`@/assets/achievements/${notification.data.image}`)"
            @click="removeNotification(notification.uid)"
            alt
          />
        </router-link>
        <div class="content">
          <h1>Achievement: {{ notification.data.title }}</h1>
          <p>{{ notification.data.description }}</p>
          <p class="exp-label">+{{ notification.data.expReward }}exp</p>
        </div>
      </div>

      <!-- PRIVATE DUEL -->
      <div class="notification" v-if="notification.type === 'duel'">
        <router-link :to="`/notifications`">
          <div class="thumbnail" @click="removeNotification(notification.uid)">
            <Avatar
              :online="false"
              :username="notification.username"
              :size="80"
            />
          </div>
        </router-link>
        <div class="content">
          <h1>New Challange</h1>
          <p>
            <router-link :to="`/user/${notification.username}`">{{
              notification.username
            }}</router-link>
            has challenged you to a private duel
          </p>
        </div>
      </div>

      <!-- CHAT MENTION -->
      <div class="notification" v-if="notification.type === 'chat'">
        <router-link :to="`/notifications`">
          <div class="thumbnail" @click="removeNotification(notification.uid)">
            <Avatar
              :online="false"
              :username="notification.username"
              :size="80"
            />
          </div>
        </router-link>
        <div class="content">
          <h1>Chat Mention</h1>
          <p>
            <router-link :to="`/user/${notification.username}`">{{
              notification.username
            }}</router-link>
            has mentioned you in the community chat
          </p>
        </div>
      </div>

      <!-- ANNOUNCEMENT -->
      <div class="notification" v-if="notification.type === 'announcement'">
        <router-link :to="`/notifications`">
          <div class="thumbnail" @click="removeNotification(notification.uid)">
            <Avatar
              :online="false"
              :username="notification.username"
              :size="80"
            />
          </div>
        </router-link>
        <div class="content">
          <h1>New Announcement</h1>
          <p>
            <router-link :to="`/user/${notification.username}`">{{
              notification.username
            }}</router-link>
            has made a new announcement
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from "../Avatar.vue";
export default {
  components: { Avatar },
  data: function() {
    return {
      notifications: []
      /* sample notifications */
      //   notifications: [
      //     {
      //       uid: 5,
      //       type: "error",
      //       data: "You've met with a terrible fate."
      //     },
      //     {
      //       uid: 1,
      //       type: "achievement",
      //       data: {
      //         title: "Welcome to GearCaster!",
      //         description: "Claimed an account",
      //         image: "claimedAccount.png",
      //         expReward: 15
      //       }
      //     },
      //     {
      //       uid: 12,
      //       type: "leveledUp",
      //       data: 'novice'
      //     }
      //   ],
    };
  },
  sockets: {
    achievementAcquired(data) {
      this.addNotification("achievement", data);
    },
    userError(data) {
      this.addNotification("error", data);
    },
    leveledUp(data) {
      this.addNotification("leveledUp", data);
    },
    notification(data) {
      this.notifications = [
        { uid: this.uuid(), ...data },
        ...this.notifications
      ];
    }
  },
  methods: {
    addNotification(type, data) {
      this.notifications = [
        { uid: this.uuid(), type, data },
        ...this.notifications
      ];
    },
    removeNotification(uid) {
      const notif = this.notifications.find(n => n.uid === uid);
      if (notif) {
        if (notif.id) {
          this.$socket.emit("notification.setRead", notif.id, true);
        }
        this.notifications = this.notifications.filter(n => n.uid !== uid);
      }
    },
    uuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        let r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  },
  watch: {
    "$route.name"(name) {
      if (name === "notifications") {
        this.notifications = [];
      }
    }
  }
};
</script>
<style scoped>
.global-notifications {
  position: absolute;
  max-height: 100vh;
  overflow: hidden;
  top: 0;
  right: 1em;
  max-width: 500px;
  z-index: 30;
}
.notification-container {
  font-size: small;
  opacity: 0.9;
  position: relative;
  border-radius: 5px;
  margin-bottom: 1rem;
  width: 100%;
  animation: fadeIn 0.5s;
}
.notification {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background: transparent;
}
.notification .thumbnail {
  height: 80px;
  width: 80px;
  margin-right: 1rem;
  align-self: center;
  border-radius: 5px;
  overflow: hidden;
}
.notification-container {
  background: white;
}
.notification-container.error .close {
  background: linear-gradient(#db775e, #a84e48);
  border: 1px solid #bd7153;
}
.notification-container.error {
  border: 2px solid #af4033;
  background: #fce3e4;
  color: #af4033;
}
.notification-container.leveledUp {
  border: 2px solid #bdaa5a;
  background: white;
}
.notification-container.achievement {
  border: 2px solid #bdaa5a;
  background: white;
}
.achievement .exp-label {
  color: #dbc25e;
  font-weight: bold;
}

@keyframes fadeIn {
  from {
    transform: translateY(-80vh);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
